import React, { useCallback, useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Button,
  Input,
  Spinner,
} from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Select from 'react-select';
import TierMasterTable from './TierMasterTable';
const RewardTierMaster = () => {
  const [search, setSearch] = useState('');

  const options = [
    { value: 'ABCD', label: 'ABCD' },
    { value: 'EFGH', label: 'EFGH' },
    { value: 'IJKL', label: 'IJKL' },
    { value: 'MNOP', label: 'MNOP' },
    { value: 'QRST', label: 'QRST' },
    { value: 'UVWX', label: 'UVWX' },
  ];
  //
  return (
    <div className="page-content p-4 pt-0">
      <BreadCrumb titleInActive={'Ahlan'} titleActive="Tier Master" />
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Ahlan Tier Master</h4>
          </div>
        </Col>
      </Row>
      {/* Filters and search */}
      <div className="border border border-dashed card-body">
        <Row>
          <Col>
            <div className={'search-box me-2 mb-2 d-inline-block w-100'}>
              <Input
                className="form-control search"
                placeholder="Search by Wallet Id / mobile no"
                type="text"
              />
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </Col>
          <Col className="d-flex flex-wrap align-items-start gap-2">
            <Select
              id="admin_status"
              options={options}
              placeholder="Select Option"
            />
            <Select
              id="admin_status"
              options={options}
              placeholder="Select Option"
            />
            <Button className="btn btn-outline  btn-light">
              <i className="ri-catalog-fill me-1 align-bottom"></i>
              Reset
            </Button>

            <Button color={`primary`} className="btn-load">
              <span className="d-flex align-items-center">
                <span className="flex-grow-1 me-2">
                  <i className="ri-search-fill me-1 align-bottom"></i>
                  Search
                </span>
              </span>
            </Button>
          </Col>
        </Row>
      </div>
      <Row className="mt-3">
        <Col>
          <TierMasterTable />
        </Col>
      </Row>
    </div>
  );
};

export default RewardTierMaster;
